// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function AcademyIcons$ProgressImageIcon(props) {
  var __imageUrl = props.imageUrl;
  var imageUrl = __imageUrl !== undefined ? __imageUrl : "";
  var tmp;
  switch (props.progressState) {
    case "NotStarted" :
        tmp = null;
        break;
    case "Started" :
        tmp = React.createElement("circle", {
              cx: "98",
              cy: "98",
              fill: "none",
              pathLength: "100",
              r: "92",
              stroke: "#3DA3E4",
              strokeDasharray: "50 100",
              strokeLinecap: "round",
              strokeWidth: "10",
              transform: "rotate(-90 98 98)"
            });
        break;
    case "Finished" :
        tmp = React.createElement("circle", {
              cx: "98",
              cy: "98",
              fill: "none",
              r: "92",
              stroke: "#3DA3E4",
              strokeLinecap: "round",
              strokeWidth: "10",
              transform: "rotate(-90 98 98)"
            });
        break;
    
  }
  return React.createElement("svg", {
              className: props.className,
              fill: "none",
              viewBox: "0 0 196 196",
              xmlns: "http://www.w3.org/2000/svg"
            }, tmp, React.createElement("circle", {
                  cx: "98",
                  cy: "98",
                  fill: "white",
                  r: "84"
                }), React.createElement("clipPath", {
                  id: "academy-progress-image-clip"
                }, React.createElement("circle", {
                      cx: "98",
                      cy: "98",
                      r: "78"
                    })), React.createElement("image", {
                  height: "156",
                  href: imageUrl,
                  width: "156",
                  clipPath: "url(#academy-progress-image-clip)",
                  preserveAspectRatio: "xMidYMid slice",
                  x: "20",
                  y: "20"
                }));
}

var ProgressImageIcon = {
  make: AcademyIcons$ProgressImageIcon
};

function AcademyIcons$PlayButton(props) {
  return React.createElement("svg", {
              className: props.className,
              viewBox: "0 0 69 72",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M47.8,33.73a2.36,2.36,0,0,1,1.2,1.4,2.77,2.77,0,0,1,0,1.8,2.36,2.36,0,0,1-1.2,1.4l-20.4,12a2.52,2.52,0,0,1-1.9.3,3.15,3.15,0,0,1-1.7-.9,4,4,0,0,1-1.1-2V24.33a3.33,3.33,0,0,1,1.1-2.1,2.59,2.59,0,0,1,1.7-.9,2.32,2.32,0,0,1,1.8.4Z",
                  fill: "currentColor"
                }));
}

var PlayButton = {
  make: AcademyIcons$PlayButton
};

function AcademyIcons$DoubleChevronRight(props) {
  return React.createElement("svg", {
              className: props.className,
              fill: "none",
              viewBox: "0 0 12 16",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M3 2l6 6-6 6",
                  stroke: "currentColor",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "2.75"
                }));
}

var DoubleChevronRight = {
  make: AcademyIcons$DoubleChevronRight
};

export {
  ProgressImageIcon ,
  PlayButton ,
  DoubleChevronRight ,
}
/* react Not a pure module */
